import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem('biolosophy_lang') || 'it');

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem('biolosophy_lang', l);
  };

  const t = (obj) => {
    if (!obj) return '';
    if (typeof obj === 'string') return obj;
    return obj[lang] ?? obj.it ?? '';
  };

  React.useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const tField = (entity, field) => {
    if (!entity) return '';
    if (lang === 'en' && entity[`${field}_en`]) return entity[`${field}_en`];
    return entity[field] || '';
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tField }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
